import { MaterialTextures } from "@/state/MaterialResources";

export type RawMaterialDefinition = {
    name: string;
    ambientColor: [r: number, g: number, b: number];
    diffuseColor: [r: number, g: number, b: number];
    specularColor: [r: number, g: number, b: number];
    specularExponent: number;
    emissiveColor: [r: number, g: number, b: number];
    illuminationModel: number;
    transparency: number;
    refractiveIndex: number;
    diffuseMap?: string;
    specularColorMap?: string;
    specularHighlightMap?: string;
    metalnessMap?: string;
    roughnessMap?: string;
    bumpMap?: string;
    bumpMultiplier?: number;
    displacementMap?: string;
    roughness?: number;
    metalness?: number;
    sheen?: number;
    clearcoatThickness?: number;
    clearcoatRoughness?: number;
    anisotropy?: number;
    anisotropyRotation?: number;
};

export type RawMaterial = {
    definition: RawMaterialDefinition;
    textures: MaterialTextures;
};

export const getDefaultRawMaterialDefinition = (): RawMaterialDefinition => ({
    name: "",
    ambientColor: [1, 1, 1],
    diffuseColor: [1, 1, 1],
    specularColor: [0, 0, 0],
    specularExponent: 1,
    emissiveColor: [0, 0, 0],
    illuminationModel: 0,
    transparency: 0,
    refractiveIndex: 0,
});
